import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { ContainerBtn } from './styled';
import activatePaymentImage from '../../../../../../../../assets/illustrations/activate_payment.svg';
import activatePaymentDskImage from '../../../../../../../../assets/illustrations/activate_payment_desktop.svg';
import checkPaymentImage from '../../../../../../../../assets/illustrations/payment_activated.svg';
import checkPaymentDskImage from '../../../../../../../../assets/illustrations/payment_activated_desktop.svg';
import CardProgress from '../../../../../../../reusables/CardProgress';
import ReusableInfo from '../../../../../../../reusables/Info';
import ReusableButton from '../../../../../../../reusables/Button';
import Dialog from '../../../../../../../reusables/Dialog';
import DialogExtraCaption from '../../../../../../../reusables/Dialog/extras/caption';
import Processing from '@/presentation/components/Processing';

interface CardPaymentProps {
  title?: string;
  infoText?: string;
  buttonText?: string;
  endDate?: string;
  isPaymentActive: boolean;
  isPaymentDone: boolean;
  handlerActivatePayment: () => void;
  isLoadingActivatePayment: boolean;
  isSuccessActivatePayment: boolean;
  firstDialogSubtitle?: string;
  secondDialogSubtitle?: string;
  showActivatedPaymentModal?: boolean;
  setShowActivatedPaymentModal?: any;
  isIssuanceUniversityCard?: boolean;
}

const CardPayment = ({
  title,
  infoText,
  buttonText,
  endDate,
  isPaymentActive,
  isPaymentDone,
  handlerActivatePayment,
  isLoadingActivatePayment,
  isSuccessActivatePayment,
  firstDialogSubtitle,
  secondDialogSubtitle,
  showActivatedPaymentModal,
  setShowActivatedPaymentModal,
  isIssuanceUniversityCard
}: CardPaymentProps) => {
  const history = useHistory();

  const [activatePaymentModal, setActivatePaymentModal] = useState(false);
  const [createdPaymentModal, setCreatedPaymentModal] = useState(true);

  let images = {};
  let onClickFunction = () => {};

  if (!isPaymentActive) {
    images = [activatePaymentImage, activatePaymentDskImage];
    onClickFunction = () => setActivatePaymentModal(true);
  } else if (isPaymentActive && !isPaymentDone) {
    images = [checkPaymentImage, checkPaymentDskImage];
    onClickFunction = () => history.push('/pagos');
  }

  return (
    <div data-testid="cmp-card-payment">
      {!isPaymentActive || (isPaymentActive && !isPaymentDone) ? (
        <CardProgress image={images} title={title}>
          <ReusableInfo
            style={{ margin: '12px 0px 0px 0px' }}
            text={infoText ?? ''}
          />
          <ContainerBtn>
            <ReusableButton
              text={buttonText ?? ''}
              style={{ marginTop: '32px' }}
              onClick={() => onClickFunction()}
            />
          </ContainerBtn>
        </CardProgress>
      ) : (
        <>{endDate}.</>
      )}
      {/* MODALES */}
      <Dialog
        handlerButtonA={() => {
          handlerActivatePayment();
          setActivatePaymentModal(false);
        }}
        handlerButtonB={() => setActivatePaymentModal(false)}
        handlerClose={() => setActivatePaymentModal(false)}
        maxWidth="360px"
        show={activatePaymentModal}
        textButtonA="Sí, actívalo"
        textButtonB="Cancelar"
        zIndex={1000}
        persistence
      >
        <DialogExtraCaption
          subtitle={firstDialogSubtitle}
          title="¿Estás seguro de activar el pago?"
        />
      </Dialog>
      <Processing isOpen={isLoadingActivatePayment} />
      {isSuccessActivatePayment && showActivatedPaymentModal && (
        <Dialog
          handlerButtonA={() => history.push('/pagos')}
          handlerButtonB={() => {
            setCreatedPaymentModal(false);
            setShowActivatedPaymentModal(false);
          }}
          handlerClose={() => {
            setCreatedPaymentModal(false);
            setShowActivatedPaymentModal(false);
          }}
          maxWidth="360px"
          show={createdPaymentModal}
          textButtonA="Ir a pagos"
          textButtonB="Lo haré después"
          zIndex={1000}
          persistence
        >
          <DialogExtraCaption
            subtitle={secondDialogSubtitle}
            title="¡Listo!"
            title2="Se ha creado el pago"
          />
          {isIssuanceUniversityCard && (
            <div style={{ margin: '16px 32px 0px 32px', textAlign: 'center' }}>
              Ya se encuentra disponible tu pago. Recuerda que una vez realizado
              el pago podrás recoger tu carné universitario.
            </div>
          )}
        </Dialog>
      )}
    </div>
  );
};
export default CardPayment;
